/**
 * Every keyboard shortcut lives here (CLAUDE.md §5.3). The `?` sheet, palette hints and tooltips
 * all read from this list.
 */
export type ShortcutId =
  | 'palette'
  | 'help'
  | 'newPosition'
  | 'goPositions'
  | 'goAlerts'
  | 'goStats'
  | 'goCharts'
  | 'goWatchlist'
  | 'goSettings'
  | 'next'
  | 'previous'
  | 'open'
  | 'recordFill'
  | 'toggleSidebar'
  | 'toggleInspector'
  | 'submit'
  | 'close';

export interface ShortcutDef {
  id: ShortcutId;
  /** Display keys; `mod` renders as ⌘ on macOS and Ctrl elsewhere. */
  keys: readonly string[];
  group: 'general' | 'navigation' | 'positions';
}

export const SHORTCUTS: readonly ShortcutDef[] = [
  { id: 'palette', keys: ['mod', 'K'], group: 'general' },
  { id: 'help', keys: ['?'], group: 'general' },
  { id: 'toggleSidebar', keys: ['['], group: 'general' },
  { id: 'toggleInspector', keys: [']'], group: 'general' },
  { id: 'submit', keys: ['mod', '↵'], group: 'general' },
  { id: 'close', keys: ['Esc'], group: 'general' },
  { id: 'goPositions', keys: ['G', 'P'], group: 'navigation' },
  { id: 'goAlerts', keys: ['G', 'A'], group: 'navigation' },
  { id: 'goStats', keys: ['G', 'S'], group: 'navigation' },
  { id: 'goCharts', keys: ['G', 'C'], group: 'navigation' },
  { id: 'goWatchlist', keys: ['G', 'W'], group: 'navigation' },
  { id: 'goSettings', keys: ['G', ','], group: 'navigation' },
  { id: 'newPosition', keys: ['C'], group: 'positions' },
  { id: 'next', keys: ['J'], group: 'positions' },
  { id: 'previous', keys: ['K'], group: 'positions' },
  { id: 'open', keys: ['↵'], group: 'positions' },
  { id: 'recordFill', keys: ['F'], group: 'positions' },
];

export function shortcutOf(id: ShortcutId): readonly string[] {
  return SHORTCUTS.find((s) => s.id === id)?.keys ?? [];
}

export function isMac(): boolean {
  return typeof navigator !== 'undefined' && /Mac|iPhone|iPad/.test(navigator.platform);
}

export function modKey(): string {
  return isMac() ? '⌘' : 'Ctrl';
}
